import { CaretDownIcon, TrashSimpleIcon, XIcon } from '@phosphor-icons/react';
import { Select as AntdSelect } from 'antd';
import type { ComponentProps } from 'react';

import styles from './select.module.scss';

type AntdSelectProps = Omit<
  ComponentProps<typeof AntdSelect>,
  'size' | 'suffixIcon' | 'allowClear' | 'removeIcon' | 'tagRender'
>;

export type SelectSize = 'default' | 'compact';

export type SelectProps = AntdSelectProps & {
  selectSize?: SelectSize;
  allowClear?: boolean;
};

export function Select({
  selectSize = 'default',
  allowClear = false,
  className,
  classNames,
  ...rest
}: SelectProps) {
  return (
    <AntdSelect
      {...rest}
      suffixIcon={<CaretDownIcon size={14} aria-hidden />}
      allowClear={
        allowClear ? { clearIcon: <TrashSimpleIcon size={14} aria-label="Clear" /> } : false
      }
      tagRender={({ label, closable, onClose }) => (
        <span className={styles.tag}>
          <span className={styles.tagLabel}>{label}</span>
          {closable ? (
            <button
              type="button"
              className={styles.tagRemove}
              aria-label={`Remove ${String(label)}`}
              onMouseDown={(event) => event.stopPropagation()}
              onClick={onClose}
            >
              <XIcon size={10} aria-hidden />
            </button>
          ) : null}
        </span>
      )}
      classNames={{
        ...classNames,
        popup: {
          root: [styles.popup, (classNames as { popup?: { root?: string } })?.popup?.root]
            .filter(Boolean)
            .join(' '),
        },
      }}
      className={[styles.select, selectSize === 'compact' ? styles.compact : undefined, className]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
